import { render } from "./AIChat.vue?vue&type=template&id=b8cf7ce2&ts=true"
import script from "./AIChat.vue?vue&type=script&lang=ts"
export * from "./AIChat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AIChat/AIChat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b8cf7ce2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b8cf7ce2', __exports__)) {
    api.reload('b8cf7ce2', __exports__)
  }
  
  module.hot.accept("./AIChat.vue?vue&type=template&id=b8cf7ce2&ts=true", () => {
    api.rerender('b8cf7ce2', render)
  })

}


export default __exports__